import { render } from "./AdminMonthlyReport.vue?vue&type=template&id=077b1f4a&ts=true"
import script from "./AdminMonthlyReport.vue?vue&type=script&lang=ts"
export * from "./AdminMonthlyReport.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__